












































































































































































































import CancelButton from '@/components/buttons/CancelButton.vue'
import SubmitButton from '@/components/buttons/SubmitButton.vue'
import { useErrors } from '@/components/composables/useErrors'
import TenderService from '@/services/tender'
import { LotWithOffersDTO, TenderWithOffersDTO } from '@/services/tender/types'
import {
  errorMessages,
  formatDate,
  formatDateTime,
  formatTime,
  parseAndJoin,
  renderDeliveryProfile,
} from '@/utils/helpers'
import ConfirmOffer from '@/views/Tender/Evaluation/partials/ConfirmOffer.vue'
import TotalAcceptedPower from '@/views/Tender/Evaluation/partials/TotalAcceptedPower.vue'
import OfferStatus from '@/views/Tender/partials/OfferStatus.vue'
import { defineComponent } from '@vue/composition-api'
import { AxiosError } from 'axios'
import { VueEditor } from 'vue2-editor'

export default defineComponent({
  name: 'EvaluationOffers',
  components: { TotalAcceptedPower, ConfirmOffer, OfferStatus, SubmitButton, CancelButton, VueEditor },
  setup() {
    const { errors, clearFieldError } = useErrors()

    return {
      formatDate,
      formatTime,
      renderDeliveryProfile,
      parseAndJoin,
      errors,
      clearFieldError,
      activeKey: 0,
    }
  },
  props: {
    lots: {
      type: Array as () => LotWithOffersDTO[],
      required: true,
    },
  },
  computed: {
    activeLot(): LotWithOffersDTO {
      return (
        this.lots[this.activeKey] || {
          id: 0,
          capacityUnit: '',
          power: 0,
          quantity: 0,
          totalLotHours: 0,
          totalConfirmedPower: 0,
          startDate: '',
          endDate: '',
          weekDay: '',
          startTime: '',
          endTime: '',
          cbcCoverage: true,
          crossBorderCapacity: {},
          deliveryProfile: [],
          lotBids: [],
          direction: '',
          createdAt: '',
          updatedAt: '',
        }
      )
    },
    totalAcceptedPower() {
      let sum = 0
      this.activeLot.lotBids.forEach(({ confirmedPower }) => {
        if (confirmedPower) sum = sum + Number(confirmedPower)
      })
      return sum
    },
  },
  methods: {
    formatDateTime,
    setErrors(errors: { [x: string]: string[] }) {
      this.errors.value = errors
    },
    calculatedTotal(quantity: number, unit: number) {
      return unit ? quantity * unit : 0
    },
    async confirm(data: TenderWithOffersDTO): Promise<void> {
      this.$emit('updated', data)
    },
    async revert(id: number): Promise<void> {
      const loader = this.$loading.show()
      try {
        const response = await TenderService.revertBid(id)
        if (response) {
          this.$toast.success(response.data.message)
        }
        this.$emit('updated', response.data.data)
      } catch (err: unknown) {
        const axiosError = err as AxiosError
        if (axiosError?.response?.data) {
          this.$toast.error(errorMessages(axiosError.response.data.message))
          return
        }
        this.$toast.error(this.$t('somethingWentWrong') as string)
      } finally {
        loader.hide()
      }
    },
  },
})
